import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import type { AssignedAudioFileSpeaker } from '../types/backend-dto-types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export const useAssignAudioBlockToNewSpeaker = (matterId: string | undefined, docId: string | undefined) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (audioBlockId: string): Promise<AssignedAudioFileSpeaker> => {
      const response = await fetch(
        `${APIBaseChronos}/api/matters/${matterId}/audio/blocks/${audioBlockId}/new-file-speaker`,
        getFetchConfig({ method: FetchMethod.PATCH }),
      );
      if (!response.ok) throw new Error('Assigning block to a new speaker failed');
      return response.json();
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries([QueryEntity.AudioSpeakerFiles]),
        queryClient.invalidateQueries([QueryEntity.DocumentAudioBlocks, { docId }]),
      ]);
    },
    onError: () => {
      toast.error('Failed to assign block to a new speaker');
    },
  });
};
